module.exports = __webpack_public_path__ + "img/kopsurat_permata_keluarga.a990bd0c.png";